const Regex = {
  NAME: /^[\D]{3,30}$/,
  USERNAME: /^[A-Za-z0-9._]{3,20}$/,
  USERNAME_MASK: /[^A-Za-z0-9._]$/,
};

export default Regex;
